
class FirecrawlService {
  private static API_KEY = import.meta.env.VITE_FIRECRAWL_API_KEY;
  private static BASE_URL = "https://api.firecrawl.com/v1";

  static async extractBrandData(url: string) {
    try {
      const response = await fetch(`${this.BASE_URL}/extract`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.API_KEY}`
        },
        body: JSON.stringify({ url })
      });

      if (!response.ok) {
        throw new Error('Failed to extract brand data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error extracting brand data:', error);
      throw error;
    }
  }
}

export default FirecrawlService;
